import { AppointmentRequestStatus } from 'graphql/generated/remote-schema-hasura';

export const classNameRequestStatus = {
  [AppointmentRequestStatus.Approved]:
    'text-bright-green border-bright-green bg-green-50',
  [AppointmentRequestStatus.Pending]:
    'bg-yellow text-amber-border border-amber-border',
  [AppointmentRequestStatus.Declined]: 'text-clc-red border-clc-red bg-red-50',
  [AppointmentRequestStatus.Outdated]: 'text-clc-red border-clc-red bg-red-50',
};

export const textRequestStatus = {
  [AppointmentRequestStatus.Approved]:
    'Patient accepted the appointment request',
  [AppointmentRequestStatus.Pending]:
    'Request sent. Patient has not responded yet',
  [AppointmentRequestStatus.Declined]:
    'Patient did not accept the proposed visit',
  [AppointmentRequestStatus.Outdated]: 'No response was received',
};

export const textTooltipStatus = {
  [AppointmentRequestStatus.Approved]: 'Request accepted by patient',
  [AppointmentRequestStatus.Pending]:
    'Request sent but not yet answered by patient',
  [AppointmentRequestStatus.Declined]: 'Request declined by patient',
  [AppointmentRequestStatus.Outdated]:
    'Proposed appointment date/time has passed without patient response',
};
